import { Heading } from '@purpur/library';
import styled from 'styled-components';

import { getPurpurSpacing, purpurMedia } from '@telialt/common-theme/src/purpurSelectors';

export const RetailsWrapper = styled.div`
    width: 100%;
    display: grid;
    grid-template-columns: 1fr;
    grid-template-areas:
        'above'
        'map'
        'below';
    margin-top: 1.125rem;
    gap: 0 ${getPurpurSpacing('300')};

    ${purpurMedia('xl')`
        grid-template-columns: 1fr auto;
        grid-template-areas:
            'above  map'
            'below  map';
    `};
`;

type ItemsContainerProps = {
    $gridArea: string;
};

export const ItemsContainer = styled.div<ItemsContainerProps>`
    grid-area: ${({ $gridArea }) => $gridArea};
    display: flex;
    flex-direction: column;
`;

export const FieldWrapper = styled.div`
    padding-top: ${getPurpurSpacing('300')};
    padding-bottom: ${getPurpurSpacing('300')};
`;

export const FieldLabel = styled(Heading)`
    margin-bottom: ${getPurpurSpacing('300')};
`;

export const NotFoundMessage = styled.div`
    padding: ${getPurpurSpacing('200')} 0;
`;
